// ** Icons Import
import { CheckSquare, Circle, EyeOff, FileText, Folder, LifeBuoy, Menu, MessageSquare, Settings, PieChart, Calendar, Book } from 'react-feather'

export default [
  {
    header: 'Misc'
  },
  // {
  //   id: 'notice-board',
  //   title: 'Notice',
  //   icon: <Book size={10} />,
  //   action: 'read',
  //   resource: 'ACL',
  //   navLink: '/apps/notice-board'
  // },
  // {
  //   id: 'products',
  //   title: 'Products',
  //   icon: <ShoppingCart size={10} />,
  //   action: 'read',
  //   resource: 'ACL',
  //   navLink: '/apps/work/products'
  // },
  // {
  //   id: 'reports',
  //   title: 'Reports',
  //   icon: <PieChart size={10} />,
  //   action: 'read',
  //   resource: 'ACL',
  //   children: [
  //     {
  //       id: 'task-report',
  //       title: 'Task-Report',
  //       icon: <Circle size={12} />,
  //       navLink: '/apps/task-report',
  //       action: 'read',
  //       resource: 'ACL'
  //     },
  //   ]
  // },

  // {
  //   id: 'settings',
  //   title: 'Settings',
  //   icon: <Settings size={10} />,
  //   action: 'read',
  //   resource: 'ACL',
  //   children: [
  //     {
  //       id: 'Roles-&-Permissions',
  //       title: 'Roles & Permissions',
  //       icon: <Circle size={12} />,
  //       navLink: '/apps/settings/role-permissions',
  //       action: 'read',
  //       resource: 'ACL'
  //     },
  //     {
  //       id: 'notification',
  //       title: 'Notification',
  //       icon: <Circle size={12} />,
  //       navLink: '/apps/settings/notification',
  //       action: 'read',
  //       resource: 'ACL'
  //     },
  //     {
  //       id: 'module-settings',
  //       title: 'Module Settings',
  //       icon: <Circle size={12} />,
  //       navLink: '/apps/settings/module-settings',
  //       action: 'read',
  //       resource: 'ACL'
  //     },
  //     {
  //       id: 'custom-fields',
  //       title: 'Custom Fields',
  //       icon: <Circle size={12} />,
  //       navLink: '/apps/settings/custom-fields',
  //       action: 'read',
  //       resource: 'ACL'
  //     },
  //     {
  //       id: 'account-settings',
  //       title: 'Company',
  //       icon: <Circle size={12} />,
  //       navLink: '/apps/settings/company-settings',
  //       action: 'read',
  //       resource: 'ACL'
  //     },
  //     {
  //       id: 'form-setting-proposal',
  //       title: 'Proposal',
  //       icon: <Circle size={10} />,
  //       navLink: '/apps/settings/proposal',
  //       action: 'read',
  //       resource: 'ACL'
  //     },
  //     {
  //       id: 'tickets-settings',
  //       title: 'Support',
  //       icon: <Circle size={12} />,
  //       navLink: '/apps/settings/tickets',
  //       action: 'read',
  //       resource: 'ACL'
  //     },
  //     {
  //       id: 'chat-settings',
  //       title: 'Workchat',
  //       icon: <Circle size={12} />,
  //       action: 'read',
  //       resource: 'ACL',
  //       children: [
  //         {
  //           id: 'list-chat-widget',
  //           title: 'All Widget',
  //           navLink: '/apps/settings/setting-chat-widgets',
  //           action: 'read',
  //           resource: 'ACL'
  //         },
  //         {
  //           id: 'form-setting-widget',
  //           title: 'Widget Setup',
  //           navLink: '/apps/settings/form-chat-widget',
  //           action: 'read',
  //           resource: 'ACL'
  //         },
  //         {
  //           id: 'form-setting-chat',
  //           title: 'Theme Setting',
  //           navLink: '/apps/settings/form-setting-chat',
  //           action: 'read',
  //           resource: 'ACL'
  //         },
  //         {
  //           id: 'form-connections',
  //           title: 'WhatsApp Connect',
  //           navLink: '/apps/settings/form-connections',
  //           action: 'read',
  //           resource: 'ACL'
  //         },
  //         {
  //           id: 'list-template',
  //           title: 'All Templates',
  //           navLink: '/apps/settings/templates',
  //           action: 'read',
  //           resource: 'ACL'
  //         }
  //       ]
  //     },
  //     {
  //       id: 'products',
  //       title: 'Products',
  //       icon: <Circle size={10} />,
  //       action: 'read',
  //       resource: 'ACL',
  //       navLink: '/apps/settings/products'
  //     },
  //     {
  //       id: 'billing',
  //       title: 'Billing',
  //       icon: <Circle size={10} />,
  //       action: 'read',
  //       resource: 'ACL',
  //       navLink: '/apps/settings/billing'
  //     },
  //   ]
  // },
  {
    id: 'menuLevels',
    title: 'Menu Levels',
    icon: <Menu size={20} />,
    children: [
      {
        id: 'secondLevel',
        title: 'Second Level 2.1',
        icon: <Circle size={12} />,
        navLink: ''
      },
      {
        id: 'secondLevel1',
        title: 'Second Level 2.2',
        icon: <Circle size={12} />,
        children: [
          {
            id: 'ThirdLevel',
            title: 'Third Level 3.1',
            navLink: ''
          },
          {
            id: 'ThirdLevel1',
            title: 'Third Level 3.2',
            navLink: ''
          }
        ]
      }
    ]
  },
  {
    id: 'disabledMenu',
    title: 'Disabled Menu',
    icon: <EyeOff size={20} />,
    navLink: '#',
    disabled: true
  },
  {
    id: 'documentation',
    title: 'Documentation',
    icon: <Folder size={20} />,
    externalLink: true,
    newTab: true,
    navLink: 'https://pixinvent.com/demo/vuexy-react-admin-dashboard-template/documentation'
  },
  {
    id: 'raiseSupport',
    title: 'Raise Support',
    icon: <LifeBuoy size={20} />,
    externalLink: true,
    newTab: true,
    navLink: 'https://pixinvent.ticksy.com/'
  }
]
